import {
  GETDICTIONARY,
  GETLOGINSTATUS,
  GETMENUOPENTYPE,
  GETOPTLOG,
  GETOPTTYPE,
  GETOPTTYPELIST,
} from '../constants'

const init = {
  total: 0,
  dictionaryList: [],
  optTypeList: [],
  optStatusList: [],
  menuOpenType: [],
}

export default function getDictionary(state = init, action) {
  if (action.type === GETDICTIONARY) {
    // console.log('123213')
    return {
      ...state,
      total: action.payload.total,
      dictionaryList: action.payload.data,
    }
  }
  if (action.type === GETOPTTYPE) {
    return {
      ...state,
      optTypeList: action.payload,
    }
  }
  if (action.type === GETOPTTYPELIST) {
    return {
      ...state,
      optTypeLists: action.payload,
    }
  }
  if (action.type === GETLOGINSTATUS) {
    return {
      ...state,
      optStatusList: action.payload,
    }
  }
  if (action.type === GETMENUOPENTYPE) {
    return {
      ...state,
      menuOpenType: action.payload,
    }
  }
  return state
}
